<template>
  <div>
    <global-loading v-if="$store.state.kpiStore.sla_loading" />
    <div class="dashboard-bottom p-2" style="position:relative">
      <div class="text-bold text-center">
        {{ title }}
      </div>
      <div class="pointer" style="position:absolute;right:7%; top: 2%;" @click="openModal">
        <i class="fa fa-cog" style="color:red; font-size: large;"></i>
      </div>
      <div class="pointer" style="position:absolute;right:3%; top: 2%;" @click="downloadReport()">
        <i class="fa-solid fa-file-arrow-down" style="color:red;  font-size: large;"></i>
      </div>
      <div style="position:absolute; top:8%; left: 5%;">
        <p class="text-sm keterangan" style="color:white; background-color: red; padding: 0 .3rem;">
          Keterangan: 9 Jam = 1 Hari
        </p>
      </div>
      <chart :chartData="chartData" :options="chartOptions" :styles="{ height: '100%', width: '100%' }" v-if="sla" />
    </div>
    <modal :isOpen="$store.state.kpiStore.modal_default" @close="closeModal" />
    <modal-reg-sap :isOpen="$store.state.kpiStore.modal_reg_sap" @close="closeModal" />
    <modal-ext :isOpen="$store.state.kpiStore.modal_ext" @close="closeModal" />
    <modal-k3l :isOpen="$store.state.kpiStore.modal_k3l" @close="closeModal" />
    <modal-kplh :isOpen="$store.state.kpiStore.modal_kplh" @close="closeModal" />
    <modal-csi :isOpen="$store.state.kpiStore.modal_csi" @close="closeModal" />
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'

export default {
  props: ['title'],
  components: {
    chart: () => import('@/components/chart/dashboard/bar-chart.vue'),
    Modal: () => import('@/components/dashboard/main-kpi/modal-conf.vue'),
    ModalRegSap: () => import('@/components/dashboard/main-kpi/modal-registrasi-sap.vue'),
    ModalExt: () => import('@/components/dashboard/main-kpi/modal-ext-sap.vue'),
    ModalK3l: () => import('@/components/dashboard/main-kpi/modal-K3L.vue'),
    ModalKplh: () => import('@/components/dashboard/main-kpi/modal-kplh.vue'),
    ModalCsi: () => import('@/components/dashboard/main-kpi/modal-csi.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },

  data() {
    return {
      isModalOpen: false,
      chartData: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
          {
            label: 'Tiket Request',
            backgroundColor: 'pink',
            data: [20, 40, 30, 50, 10, 100],
            yAxisID: 'B',
            order: 6,
          },
          {
            label: 'L3',
            backgroundColor: '#ff3333',
            borderColor: '#ff3333',
            data: [9, 9, 9, 9, 9, 9, 9],
            fill: false,
            lineTension: 0,
            yAxisID: 'A',
            type: 'line',
            order: 4,
            pointRadius: 0,
          },
          {
            label: 'L4',
            backgroundColor: '#ff8e5b',
            borderColor: '#ff8e5b',
            data: [7, 7, 7, 7, 7, 7, 7],
            fill: false,
            lineTension: 0,
            yAxisID: 'A',
            type: 'line',
            order: 3,
            pointRadius: 0,
          },
          {
            label: 'L5',
            backgroundColor: '#ff9900',
            borderColor: '#ff9900',
            data: [5, 5, 5, 5, 5, 5, 5],
            fill: false,
            lineTension: 0,
            yAxisID: 'A',
            type: 'line',
            order: 2,
            pointRadius: 0,
          },
          {
            label: 'Rata-rata Pengerjaan',
            backgroundColor: '#990000',
            borderColor: '#990000',
            fill: false,
            lineTension: 0,
            data: [1, 4, 3, 5, 7, 9],
            type: 'line',
            yAxisID: 'A',
            order: 1,
          },
        ],
      },
      chartOptions: {
        showDatapoints: true,
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: '',
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        tooltips: {
          mode: 'index',
          axis: 'y',
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''
              const nilaiAsli =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]

              if (label) {
                label += ': '
              }
              if (label != 'Tiket Request: ') {
                let convertedValue = nilaiAsli
                function konversiMenitKeHariJamMenit(menit) {
                  if (typeof menit !== 'number' || menit <= 0) {
                    // return `Masukkan jumlah menit yang valid (angka positif). ==> ${menit}`
                    return '0 menit'
                  }

                  const satuHariDalamMenit = 9 * 60
                  const satuJamDalamMenit = 60

                  const hari = Math.floor(menit / satuHariDalamMenit)
                  const sisaMenitSetelahHari = menit % satuHariDalamMenit

                  const jam = Math.floor(
                    sisaMenitSetelahHari / satuJamDalamMenit
                  )
                  const sisaMenit = sisaMenitSetelahHari % satuJamDalamMenit

                  let hasil = ''
                  if (hari > 0) {
                    hasil += hari + ' hari '
                  }
                  if (jam > 0) {
                    hasil += jam + ' jam '
                  }
                  if (sisaMenit > 0) {
                    hasil += Math.round(sisaMenit) + ' menit'
                  }

                  return hasil.trim()
                }
                let result = konversiMenitKeHariJamMenit(convertedValue)
                return (label += result)
                // if (nilaiAsli < 9 * 60) {
                //   const jam = nilaiAsli > 60 ? Math.round(nilaiAsli / 60) : 0
                //   const menit = Math.round(nilaiAsli % 60)
                //   return (label += `${jam} jam ${menit} menit`)

                // }
                // else {
                //   const hari = Math.round(nilaiAsli / (9 * 60))
                //   const jam = Math.round((nilaiAsli % (9 * 60)) / 60)
                //   return (label += `${hari} hari ${jam} jam`)

                // }
              } else {
                return (label += `${nilaiAsli} Tiket Selesai`)
              }
            },
          },
        },
        scales: {
          yAxes: [
            {
              id: 'A',
              position: 'left',
              ticks: {
                beginAtZero: true,
                stepSize: 540,
                callback: function (value, index, ticks) {
                  return Math.ceil(value / 540)
                },
              },
              scaleLabel: {
                display: true,
                labelString: 'Hari',
              },
            },
            {
              id: 'B',
              position: 'right',
              ticks: {
                beginAtZero: true,
                callback: function (value, index, ticks) {
                  if (Number.isInteger(value)) {
                    return value
                  }
                },
              },
              scaleLabel: {
                display: true,
                labelString: 'Tiket',
              },
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Periode',
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    sla() {
      let data = this.$store.state.kpiStore.slaData
      this.convertData(data)

      return data
    },
  },
  methods: {
    openModal() {
      const currentPage = this.$store.state.kpiStore.active_page
      switch (currentPage) {
        case 'for_isupplier':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_default',
            value: true,
          })
          break
        case 'for_sap':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_reg_sap',
            value: true,
          })
          break
        case 'for_extend_sap':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_ext',
            value: true,
          })
          break
        case 'for_k3l':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_k3l',
            value: true,
          })
          break
        case 'for_kplh':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_kplh',
            value: true,
          })
          break
        case 'for_csi':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_csi',
            value: true,
          })
          break

        default:
          break
      }
    },
    closeModal() {
      const currentPage = this.$store.state.kpiStore.active_page
      switch (currentPage) {
        case 'for_isupplier':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_default',
            value: false,
          })
          break
        case 'for_sap':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_reg_sap',
            value: false,
          })
          break
        case 'for_extend_sap':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_ext',
            value: false,
          })
          break
        case 'for_k3l':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_k3l',
            value: false,
          })
          break
        case 'for_kplh':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_kplh',
            value: false,
          })
          break
        case 'for_csi':
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: 'modal_csi',
            value: false,
          })
          break

        default:
          break
      }
    },
    submitForm() {
      this.isModalOpen = false
    },
    convertData(data) {
      this.$store.commit('kpiStore/UPDATE_DATA', {
        name: 'sla_loading',
        value: true,
      })

      const activePage = this.$store.state.kpiStore.active_page

      const timeSet = this.$store.state.kpiStore[`${activePage}_value`]

      try {
        if (data && data.length > 0) {
          let monthYear = {}

          data.forEach(item => {
            if (
              monthYear[`${this.monthConverter(item.bulan)}-${item.tahun}`] ==
              undefined
            ) {
              monthYear[`${this.monthConverter(item.bulan)}-${item.tahun}`] = {
                sla: Number(item.sla.sla_min),
                sla_penilai: Number(item.sla.sla_penilai),
                sla_sipm: Number(item.sla.sla_sipm),
                ticket: 1,
              }
            } else {
              monthYear[`${this.monthConverter(item.bulan)}-${item.tahun}`] = {
                sla:
                  Number(
                    monthYear[
                      `${this.monthConverter(item.bulan)}-${item.tahun}`
                    ].sla
                  ) + Number(item.sla.sla_min),
                sla_penilai:
                  Number(
                    monthYear[
                      `${this.monthConverter(item.bulan)}-${item.tahun}`
                    ].sla_penilai
                  ) + Number(item.sla.sla_penilai),
                sla_sipm:
                  Number(
                    monthYear[
                      `${this.monthConverter(item.bulan)}-${item.tahun}`
                    ].sla_sipm
                  ) + Number(item.sla.sla_sipm),
                ticket:
                  monthYear[`${this.monthConverter(item.bulan)}-${item.tahun}`]
                    .ticket + 1,
              }
            }
            // }
          })

          let labels = Object.keys(monthYear)
          let dataSets = [
            {
              label: 'Tiket Request',
              backgroundColor: 'pink',
              data: [],
              yAxisID: 'B',
              order: 6,
            },
            {
              label: 'L3',
              backgroundColor: '#ff3333',
              borderColor: '#ff3333',
              data: [],
              fill: false,
              lineTension: 0,
              yAxisID: 'A',
              type: 'line',
              order: 4,
              pointRadius: 0,
            },
            {
              label: 'L4',
              backgroundColor: '#ff8e5b',
              borderColor: '#ff8e5b',
              data: [],
              fill: false,
              lineTension: 0,
              yAxisID: 'A',
              type: 'line',
              order: 3,
              pointRadius: 0,
            },
            {
              label: 'L5',
              backgroundColor: '#ff9900',
              borderColor: '#ff9900',
              data: [],
              fill: false,
              lineTension: 0,
              yAxisID: 'A',
              type: 'line',
              order: 2,
              pointRadius: 0,
            },
            {
              label: 'Rata-rata Pengerjaan',
              backgroundColor: '#990000',
              borderColor: '#990000',
              fill: false,
              lineTension: 0,
              data: [],
              type: 'line',
              yAxisID: 'A',
              order: 1,
            },
          ]

          if (activePage == 'for_k3l' || activePage == 'for_kplh') {
            dataSets.splice(1, 1)
            dataSets.push({
              label: 'Rata-rata Pengerjaan',
              backgroundColor: '#ff3333',
              borderColor: '#ff3333',
              fill: false,
              lineTension: 0,
              data: [],
              type: 'line',
              yAxisID: 'A',
              order: 1,
            })
          }
          for (let i in labels) {
            let slaValue = Number(monthYear[`${labels[i]}`].sla)
            let slaPenilaiValue = Number(monthYear[`${labels[i]}`].sla_penilai)
            let slaSipmValue = Number(monthYear[`${labels[i]}`].sla_sipm)
            let totalTicket = Number(monthYear[`${labels[i]}`].ticket)
            dataSets[0].data.push(totalTicket)

            if (timeSet) {
              if (
                activePage == 'for_isupplier' ||
                activePage == 'for_sap' ||
                activePage == 'for_extend_sap'
              ) {
                dataSets[4].data.push(Math.floor(slaValue / totalTicket))

                dataSets[3].data.push(
                  Number(timeSet.endL5Hour) * 60 + Number(timeSet.endL5Minute)
                )
                dataSets[2].data.push(
                  Number(timeSet.endL4Hour) * 60 + Number(timeSet.endL4Minute)
                )
                dataSets[1].data.push(
                  Number(timeSet.endL3Hour) * 60 + Number(timeSet.endL3Minut)
                )
              }

              // if (activePage == 'for_k3l' || activePage == 'for_kplh') {
              //   dataSets[4].data.push(Math.round(slaPenilaiValue / totalTicket))
              //   dataSets[3].data.push(Math.round(slaSipmValue / totalTicket))

              //   dataSets[1].data.push(
              //     Number(timeSet.endSIPMHour) * 60 +
              //       Number(timeSet.endSIPMMinute)
              //   )
              //   dataSets[4].data.push(
              //     Number(timeSet.endPenilaiHour) * 60 +
              //       Number(timeSet.endPenilaiMinute)
              //   )

              //     dataSets[4].label = 'Rata-rata Pengerjaan SIPM'
              //     dataSets[3].label = 'Rata-rata Pengerjaan Penilai'
              //     dataSets[2].label = 'Target SIPM'
              //     dataSets[1].label = 'Target Penilai'
              //   }
              // } else {
              // if (
              //   activePage == 'for_isupplier' ||
              //   activePage == 'for_sap' ||
              //   activePage == 'for_extend_sap'
              // ) {
              //   dataSets[4].data.push(Math.round(slaValue / totalTicket))

              //   dataSets[3].data.push(45 * 60)
              //   dataSets[2].data.push(63 * 60)
              //   dataSets[1].data.push(81 * 60)
              // }

              if (activePage == 'for_k3l') {
                dataSets[4].data.push(Math.round(slaPenilaiValue / totalTicket))
                dataSets[3].data.push(Math.round(slaSipmValue / totalTicket))

                // dataSets[2].data.push(81 * 60)
                // dataSets[1].data.push(63 * 60)
                dataSets[2].data.push(
                  Number(timeSet.endPenilaiHour) * 60 +
                  Number(timeSet.endPenilaiMinute)
                )
                dataSets[1].data.push(
                  Number(timeSet.endSIPMHour) * 60 +
                  Number(timeSet.endSIPMMinute)
                )

                dataSets[4].label = 'Rata-rata Pengerjaan Ops.Comp'
                dataSets[3].label = 'Rata-rata Pengerjaan SIPM'
                dataSets[2].label = 'Target Ops.Comp'
                dataSets[1].label = 'Target SIPM'

                dataSets[4].backgroundColor = '#990000'
                dataSets[4].borderColor = '#990000'
                dataSets[2].backgroundColor = '#ff8e5b'
                dataSets[2].borderColor = '#ff8e5b'
                dataSets[3].backgroundColor = '#ff3333'
                dataSets[3].borderColor = '#ff3333'
                dataSets[1].backgroundColor = '#ff9900'
                dataSets[1].borderColor = '#ff9900'

                dataSets[4].order = 1
                dataSets[3].order = 3
                dataSets[2].order = 2
                dataSets[1].order = 4
              } else if (activePage == 'for_kplh') {
                dataSets[4].data.push(Math.round(slaPenilaiValue / totalTicket))
                dataSets[3].data.push(Math.round(slaSipmValue / totalTicket))

                // dataSets[2].data.push(81 * 60)
                // dataSets[1].data.push(63 * 60)
                dataSets[2].data.push(
                  Number(timeSet.endPenilaiHour) * 60 +
                  Number(timeSet.endPenilaiMinute)
                )
                dataSets[1].data.push(
                  Number(timeSet.endSIPMHour) * 60 +
                  Number(timeSet.endSIPMMinute)
                )

                dataSets[4].label = 'Rata-rata Pengerjaan HSE'
                dataSets[3].label = 'Rata-rata Pengerjaan SIPM'
                dataSets[2].label = 'Target HSE'
                dataSets[1].label = 'Target SIPM'

                dataSets[4].backgroundColor = '#990000'
                dataSets[4].borderColor = '#990000'
                dataSets[2].backgroundColor = '#ff8e5b'
                dataSets[2].borderColor = '#ff8e5b'
                dataSets[3].backgroundColor = '#ff3333'
                dataSets[3].borderColor = '#ff3333'
                dataSets[1].backgroundColor = '#ff9900'
                dataSets[1].borderColor = '#ff9900'

                dataSets[4].order = 1
                dataSets[3].order = 3
                dataSets[2].order = 2
                dataSets[1].order = 4
              }
            }
          }

          this.chartData = {
            labels: labels,
            datasets: dataSets,
          }
        } else {
          this.chartData = {
            labels: [],
            datasets: [
              {
                label: 'Tiket Request',
                backgroundColor: 'pink',
                data: [],
                yAxisID: 'B',
                order: 6,
              },
              {
                label: 'L3',
                backgroundColor: '#ff3333',
                borderColor: '#ff3333',
                data: [],
                fill: false,
                lineTension: 0,
                yAxisID: 'A',
                type: 'line',
                order: 4,
                pointRadius: 0,
              },
              {
                label: 'L4',
                backgroundColor: '#ff8e5b',
                borderColor: '#ff8e5b',
                data: [],
                fill: false,
                lineTension: 0,
                yAxisID: 'A',
                type: 'line',
                order: 3,
                pointRadius: 0,
              },
              {
                label: 'L5',
                backgroundColor: '#ff9900',
                borderColor: '#ff9900',
                data: [],
                fill: false,
                lineTension: 0,
                yAxisID: 'A',
                type: 'line',
                order: 2,
                pointRadius: 0,
              },
              {
                label: 'Rata-rata Pengerjaan',
                backgroundColor: '#990000',
                borderColor: '#990000',
                fill: false,
                lineTension: 0,
                data: [],
                type: 'line',
                yAxisID: 'A',
                order: 1,
              },
            ],
          }
        }

        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: 'sla_loading',
          value: false,
        })
      } catch (error) {
        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: 'sla_loading',
          value: false,
        })
      }
    },
    convertStatus(index) {
      switch (index) {
        case 3:
          return 'ticket_feedback'
          break
        case 4:
          return 'ticket_feedback'
          break
        case 5:
          return 'ticket_feedback'
          break
        case 11:
          return 'head_sipm_feedback'
          break
        case 12:
          return 'head_sipm_feedback'
          break
        case 13:
          return 'head_sipm_feedback'
          break
        default:
          return index
          break
      }
    },
    konversiMenitKeHariJamMenit(menit) {
      if (typeof menit !== 'number' || menit <= 0) {
        // return `Masukkan jumlah menit yang valid (angka positif). ==> ${menit}`
        return '0 menit'
      }

      const satuHariDalamMenit = 24 * 60
      const satuJamDalamMenit = 60

      const hari = Math.floor(menit / satuHariDalamMenit)
      const sisaMenitSetelahHari = menit % satuHariDalamMenit

      const jam = Math.floor(sisaMenitSetelahHari / satuJamDalamMenit)
      const sisaMenit = sisaMenitSetelahHari % satuJamDalamMenit

      let hasil = ''
      if (hari > 0) {
        hasil += hari + ' hari '
      }
      if (jam > 0) {
        hasil += jam + ' jam '
      }
      if (sisaMenit > 0) {
        hasil += Math.round(sisaMenit) + ' menit'
      }

      return hasil.trim()
    },
    async exportPq(exportTitle, exportType) {
      const data = await this.$store.dispatch('kpiStore/exportData')
      const activePage = this.$store.state.kpiStore.active_page
      const timeSet = this.$store.state.kpiStore[`${activePage}_value`]

      function getSLA(value) {
        let sipm =
          Number(timeSet.endSIPMHour) * 60 + Number(timeSet.endSIPMMinute)
        let penilai =
          Number(timeSet.endPenilaiHour) * 60 + Number(timeSet.endPenilaiMinute)
      }

      const newData = data.map((item, index) => {
        const newDataItem = {
          no: index + 1,
          no_ticket: item.code,
          type_request: this.requestType(item.type),
          requestor: item.user,
          last_status: this.requestStatus(item.status),
          created_ticket: item.createdAt,
          time_sla: item.sla,
          sla_sipm: item.sla_sipm,
          sla_penilai: item.sla_penilai,
          sla_class: getSLA(item.sla),
        }

        item.approval.forEach((approval, index) => {
          const statusIndex = approval.status
          const totalStatusProp = `total_status_${this.convertStatus(
            statusIndex
          )}`
          const updateStatusProp = `update_status_${this.convertStatus(
            statusIndex
          )}`

          if (statusIndex == 3 || statusIndex == 4 || statusIndex == 5) {
            newDataItem[totalStatusProp] = item.approval.filter(
              appr => appr.status == 3 || appr.status == 4 || appr.status == 5
            ).length
          } else if (statusIndex == 16 || statusIndex == 17) {
            if (statusIndex == 16) {
              newDataItem['update_status_16'] = approval.updatedAt
            }
            if (statusIndex == 17) {
              newDataItem['update_status_17'] = approval.updatedAt
            }

            newDataItem['total_status_penilai'] = item.approval.filter(
              appr => appr.status == 17 || appr.status == 16
            ).length
          } else {
            newDataItem[totalStatusProp] = item.approval.filter(
              appr => appr.status == statusIndex
            ).length
          }

          newDataItem[updateStatusProp] = approval.updatedAt

          if (approval.status == 5) {
            newDataItem['pic'] =
              approval && approval.approver && approval.approver.name
          }
        })

        return newDataItem
      })

      const convertNewData = newData.map(item => {
        return {
          no: item.no,
          no_ticket: item.no_ticket,
          type_request: item.type_request,
          requestor: item.requestor,
          pic: item.pic,
          last_status: item.last_status,
          created_ticket: this.formatDateTime(item.created_ticket),
          waiting_for_sipm: this.formatDateTime(item.update_status_2),
          ticket_feedback: this.formatDateTime(
            item.update_status_ticket_feedback
          ),
          wait_vendor: this.formatDateTime(item.update_status_6),
          vendor_feedback: this.formatDateTime(item.update_status_7),
          wait_validation: this.formatDateTime(item.update_status_7),
          validation_feedback: this.formatDateTime(item.update_status_15),
          wait_validation_penilai: this.formatDateTime(item.update_status_15),
          validation_penilai_feedback: this.formatDateTime(
            item.update_status_16
          ),
          wait_validation_head: this.formatDateTime(item.update_status_16),
          validation_head: this.formatDateTime(item.update_status_17),
          total_ticket_review: item.total_status_2,
          total_vendor_feedback: item.total_status_7,
          total_review_penilai: item.total_status_penilai,
          time_sla: this.konversiMenitKeHariJamMenit(Number(item.sla_sipm)),
          time_sla_penilai: this.konversiMenitKeHariJamMenit(
            Number(item.sla_penilai)
          ),
        }
      })

      let average2 = convertNewData.reduce((a, b) => {
        return a + b.total_ticket_review
      }, 0)
      let average7 = convertNewData.reduce((a, b) => {
        return a + b.total_vendor_feedback
      }, 0)
      let averagePenilai = convertNewData.reduce((a, b) => {
        return a + b.total_review_penilai
      }, 0)
      let sla = newData.reduce((a, b) => {
        return a + Number(b.sla_sipm ? b.sla_sipm : 0)
      }, 0)
      let sla_penilai = newData.reduce((a, b) => {
        return a + Number(b.sla_penilai ? b.sla_penilai : 0)
      }, 0)
      let csi = newData.reduce((a, b) => {
        return a + (b.csi ? b.csi : 0)
      }, 0)

      convertNewData.push({
        no: 'Tiket',
        no_ticket: this.countUniqueNames(convertNewData, 'no_ticket'),
        type_request: '',
        requestor: '',
        pic: this.countUniqueNames(convertNewData, 'pic'),
        last_status: '',
        created_ticket: '',
        waiting_for_sipm: '',
        ticket_feedback: '',
        wait_vendor: '',
        vendor_feedback: '',
        wait_validation: '',
        validation_feedback: '',
        wait_validation_penilai: '',
        validation_penilai_feedback: '',
        wait_validation_head: '',
        validation_head: 'Average',
        total_ticket_review: Math.round(average2 / newData.length),
        total_vendor_feedback: Math.round(average7 / newData.length),
        total_review_penilai: Math.round(averagePenilai / newData.length),
        time_sla: this.konversiMenitKeHariJamMenit(
          Math.round(sla / newData.length)
        ),
        time_sla_penilai: this.konversiMenitKeHariJamMenit(
          Math.round(sla_penilai / newData.length)
        ),
      })

      convertNewData.unshift({})

      let start = this.$store.state.kpiStore.start
      let end = this.$store.state.kpiStore.end

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(convertNewData)
        const title = [
          [
            `${exportTitle} ${start}- ${end}`,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
          ],
          [
            'No',
            'Ticket Number',
            'Type Request',
            'Requestor',
            'PIC',
            'Last Status',
            'Created Ticket',
            'Waiting For SIPM Approve',
            'Ticket Feedback',
            'Waiting For Vendor Feedback',
            'Vendor Feedback',
            'Waiting For Validation',
            'Validation Feedback',
            'Waiting For Validation Ops.Comp',
            'Validation Ops.Comp Feedback',
            'Waiting For Validation Head Ops.Comp',
            'Validation Head Ops.Comp Feedback',
            'Total Ticket Review',
            'Total Vendor Feedback',
            'Total Review Ops.Comp',
            'SLA Time SIPM',
            'SLA Time Ops.Comp',
          ],
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
    async exportPqKplh(exportTitle, exportType) {
      const data = await this.$store.dispatch('kpiStore/exportData')

      const newData = data.map((item, index) => {
        const newDataItem = {
          no: index + 1,
          no_ticket: item.code,
          type_request: this.requestType(item.type),
          requestor: item.user,
          last_status: this.requestStatus(item.status),
          created_ticket: item.createdAt,
          time_sla: item.sla,
          sla_sipm: item.sla_sipm,
          sla_penilai: item.sla_penilai,
        }

        item.approval.forEach((approval, index) => {
          const statusIndex = approval.status
          const totalStatusProp = `total_status_${this.convertStatus(
            statusIndex
          )}`
          const updateStatusProp = `update_status_${this.convertStatus(
            statusIndex
          )}`

          if (statusIndex == 3 || statusIndex == 4 || statusIndex == 5) {
            newDataItem[totalStatusProp] = item.approval.filter(
              appr => appr.status == 3 || appr.status == 4 || appr.status == 5
            ).length
          } else if (
            statusIndex == 18 ||
            statusIndex == 19 ||
            statusIndex == 20
          ) {
            if (statusIndex == 18) {
              newDataItem['update_status_118'] = approval.updatedAt
            }
            if (statusIndex == 19) {
              newDataItem['update_status_19'] = approval.updatedAt
            }
            if (statusIndex == 20) {
              newDataItem['update_status_20'] = approval.updatedAt
            }

            newDataItem['total_status_penilai'] = item.approval.filter(
              appr =>
                appr.status == 18 || appr.status == 19 || appr.status == 20
            ).length
          } else {
            newDataItem[totalStatusProp] = item.approval.filter(
              appr => appr.status == statusIndex
            ).length
          }

          newDataItem[updateStatusProp] = approval.updatedAt
          if (approval.status == 5) {
            newDataItem['pic'] =
              approval && approval.approver && approval.approver.name
          }
          // newDataItem['last_status'] = this.requestStatus(approval.status)
        })

        return newDataItem
      })

      const convertNewData = newData.map(item => {
        return {
          no: item.no,
          no_ticket: item.no_ticket,
          type_request: item.type_request,
          requestor: item.requestor,
          pic: item.pic,
          last_status: item.last_status,
          created_ticket: this.formatDateTime(item.created_ticket),
          waiting_for_sipm: this.formatDateTime(item.update_status_2),
          ticket_feedback: this.formatDateTime(
            item.update_status_ticket_feedback
          ),
          wait_vendor: this.formatDateTime(item.update_status_6),
          vendor_feedback: this.formatDateTime(item.update_status_7),
          wait_validation: this.formatDateTime(item.update_status_7),
          validation_feedback: this.formatDateTime(item.update_status_15),
          wait_validation_penilai: this.formatDateTime(item.update_status_15),
          validation_penilai_feedback: this.formatDateTime(
            item.update_status_18
          ),
          wait_val_head_penilai: this.formatDateTime(item.update_status_18),
          validation_head_penilai_feedback: this.formatDateTime(
            item.update_status_19
          ),
          waiting_validation_ktt: this.formatDateTime(item.update_status_19),
          validation_ktt_penilai: this.formatDateTime(item.update_status_20),
          total_ticket_review: item.total_status_2,
          total_vendor_feedback: item.total_status_7,
          total_review_penilai: item.total_status_penilai,
          time_sla: this.konversiMenitKeHariJamMenit(Number(item.sla_sipm)),
          time_sla_penilai: this.konversiMenitKeHariJamMenit(
            Number(item.sla_penilai)
          ),
        }
      })

      let average2 = convertNewData.reduce((a, b) => {
        return a + b.total_ticket_review
      }, 0)
      let average7 = convertNewData.reduce((a, b) => {
        return a + b.total_vendor_feedback
      }, 0)
      let averagePenilai = convertNewData.reduce((a, b) => {
        return a + b.total_review_penilai
      }, 0)
      let sla = newData.reduce((a, b) => {
        return a + Number(b.sla_sipm ? b.sla_sipm : 0)
      }, 0)
      let sla_penilai = newData.reduce((a, b) => {
        return a + Number(b.sla_penilai ? b.sla_penilai : 0)
      }, 0)
      let csi = newData.reduce((a, b) => {
        return a + (b.csi ? b.csi : 0)
      }, 0)

      convertNewData.push({
        no: 'Total',
        no_ticket: this.countUniqueNames(convertNewData, 'no_ticket'),
        type_request: '',
        requestor: '',
        pic: this.countUniqueNames(convertNewData, 'pic'),
        last_status: '',
        created_ticket: '',
        waiting_for_sipm: '',
        ticket_feedback: '',
        wait_vendor: '',
        vendor_feedback: '',
        wait_validation: '',
        validation_feedback: '',
        wait_validation_penilai: '',
        validation_penilai_feedback: '',
        wait_val_head_penilai: '',
        validation_head_penilai_feedback: '',
        waiting_validation_ktt: '',
        validation_ktt_penilai: 'Average',
        total_ticket_review: Math.round(average2 / newData.length),
        total_vendor_feedback: Math.round(average7 / newData.length),
        total_review_penilai: Math.round(averagePenilai / newData.length),
        time_sla: this.konversiMenitKeHariJamMenit(
          Math.round(sla / newData.length)
        ),
        time_sla_penilai: this.konversiMenitKeHariJamMenit(
          Math.round(sla_penilai / newData.length)
        ),
      })

      convertNewData.unshift({})

      let start = this.$store.state.kpiStore.start
      let end = this.$store.state.kpiStore.end

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(convertNewData)
        const title = [
          [
            `${exportTitle} ${start}- ${end}`,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
          ],
          [
            'No',
            'Ticket Number',
            'Type Request',
            'Requestor',
            'PIC',
            'Last Status',
            'Created Ticket',
            'Waiting For SIPM Approve',
            'Ticket Feedback',
            'Waiting For Vendor Feedback',
            'Vendor Feedback',
            'Waiting For Validation',
            'Validation Feedback',
            'Waiting For Validation HSE',
            'Validation HSE Feedback',
            'Waiting For Validation Head HSE',
            'Validation Head HSE Feedback',
            'Waiting For Validation KTT HSE',
            'Validation KTT HSE Feedback',
            'Total Ticket Review',
            'Total Vendor Feedback',
            'Total Review HSE',
            'SLA Time SIPM',
            'SLA Time HSE',
          ],
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
    async exportDataVendorBaru(exportTitle, exportType) {
      const data = await this.$store.dispatch('kpiStore/exportData')
      const activePage = this.$store.state.kpiStore.active_page
      const timeSet = this.$store.state.kpiStore[`${activePage}_value`]

      function getSLA(value) {
        let l3 = Number(timeSet.endL3Hour) * 60 + Number(timeSet.endL3Minut)
        let l4 = Number(timeSet.endL4Hour) * 60 + Number(timeSet.endL4Minute)
        let l5 = Number(timeSet.endL5Hour) * 60 + Number(timeSet.endL5Minute)

        if (value > 0 && value <= l5) {
          return 'L5'
        } else if (value > l5 && value <= l4) {
          return 'L4'
        }
        if (value > l4) {
          return 'L3'
        }
      }

      const newData = data.map((item, index) => {
        const newDataItem = {
          no: index + 1,
          no_ticket: item.code,
          type_request: exportType,
          requestor: item.user,
          // pic: item.pic,
          last_status: this.requestStatus(item.status),
          created_ticket: item.createdAt,
          time_sla: item.sla,
          sla: getSLA(item.sla),
          csi: item.csi,
        }

        item.approval.forEach((approval, index) => {
          const statusIndex = approval.status
          const totalStatusProp = `total_status_${this.convertStatus(
            statusIndex
          )}`
          const updateStatusProp = `update_status_${this.convertStatus(
            statusIndex
          )}`

          if (statusIndex == 3 || statusIndex == 4 || statusIndex == 5) {
            newDataItem[totalStatusProp] = item.approval.filter(
              appr => appr.status == 3 || appr.status == 4 || appr.status == 5
            ).length
          } else if (
            statusIndex == 11 ||
            statusIndex == 12 ||
            statusIndex == 13
          ) {
            newDataItem[totalStatusProp] = item.approval.filter(
              appr =>
                appr.status == 11 || appr.status == 12 || appr.status == 13
            ).length
          } else {
            newDataItem[totalStatusProp] = item.approval.filter(
              appr => appr.status == statusIndex
            ).length
          }

          newDataItem[updateStatusProp] = approval.updatedAt
          if (item.type == 1 && item.status == 13) {
            if (approval.status == 5) {
              newDataItem['pic'] =
                approval && approval.approver && approval.approver.name
            }
          } else if (item.type == 2 && item.status == 5) {
            if (approval.status == 9) {
              newDataItem['pic'] =
                approval && approval.approver && approval.approver.name
            }
          } else {
            if (approval.status == 5) {
              newDataItem['pic'] =
                approval && approval.approver && approval.approver.name
            }
          }
        })

        return newDataItem
      })

      const convertNewData = newData.map(item => {
        return {
          no: item.no,
          no_ticket: item.no_ticket,
          type_request: item.type_request,
          requestor: item.requestor,
          pic: item.pic,
          last_status: item.last_status,
          created_ticket: this.formatDateTime(item.created_ticket),
          waiting_for_sipm: this.formatDateTime(item.update_status_2),
          ticket_feedback: this.formatDateTime(
            item.update_status_ticket_feedback
          ),
          wait_vendor:
            exportType == 'Extend to SAP'
              ? '-'
              : this.formatDateTime(item.update_status_6),
          vendor_feedback:
            exportType == 'Extend to SAP'
              ? '-'
              : this.formatDateTime(item.update_status_7),
          wait_validation:
            exportType == 'Extend to SAP'
              ? '-'
              : this.formatDateTime(item.update_status_8),
          validation_feedback:
            exportType == 'Extend to SAP'
              ? '-'
              : this.formatDateTime(item.update_status_9),
          wait_head_sipm: this.formatDateTime(item.update_status_9),
          head_sipm_feedback:
            exportType == 'Extend to SAP'
              ? this.formatDateTime(item.update_status_ticket_feedback)
              : this.formatDateTime(item.update_status_head_sipm_feedback),
          total_ticket_review:
            exportType == 'Extend to SAP' || exportType == 'Vendor Baru SAP'
              ? Number(item.total_status_2) - 1
              : Number(item.total_status_2),
          total_vendor_feedback:
            item.total_status_7 || item.total_status_7 != undefined
              ? item.total_status_7
              : 0,
          time_sla: this.konversiMenitKeHariJamMenit(Number(item.time_sla)),
          sla: item.sla,
          csi: item.csi,
        }
      })

      let average2 = convertNewData.reduce((a, b) => {
        return a + b.total_ticket_review
      }, 0)
      let average7 = convertNewData.reduce((a, b) => {
        return a + b.total_vendor_feedback
      }, 0)
      let sla = newData.reduce((a, b) => {
        return a + Number(b.time_sla)
      }, 0)
      let csi = newData.reduce((a, b) => {
        return a + (b.csi ? b.csi : 0)
      }, 0)

      convertNewData.push({
        no: 'Total',
        no_ticket: this.countUniqueNames(convertNewData, 'no_ticket'),
        type_request: '',
        requestor: '',
        pic: this.countUniqueNames(convertNewData, 'pic'),
        last_status: '',
        created_ticket: '',
        waiting_for_sipm: '',
        ticket_feedback: '',
        wait_vendor: '',
        vendor_feedback: '',
        wait_validation: '',
        validation_feedback: '',
        head_sipm_feedback: 'Average',
        total_ticket_review: Math.round(average2 / newData.length),
        total_vendor_feedback: Math.round(average7 / newData.length),
        time_sla: this.konversiMenitKeHariJamMenit(
          Math.round(sla / newData.length)
        ),
        sla: getSLA(Math.round(sla / newData.length)),
        csi: Math.round(csi / newData.length),
      })

      convertNewData.unshift({})

      let start = this.$store.state.kpiStore.start
      let end = this.$store.state.kpiStore.end

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(convertNewData)
        const title = [
          [
            `${exportTitle} ${start}- ${end}`,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
          ],
          [
            'No',
            'Ticket Number',
            'Type Request',
            'Requestor',
            'PIC',
            'Last Status',
            'Created Ticket',
            'Waiting For SIPM Approve',
            'Ticket Feedback',
            'Waiting For Vendor Feedback',
            'Vendor Feedback',
            'Waiting For Validation',
            'Validation Feedback',
            'Waiting For Head SIPM',
            'Head SIPM Feedback',
            'Total Ticket Review',
            'Total Vendor Feedback',
            'SLA Time',
            'SLA',
            'CSI',
          ],
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
    downloadReport() {
      const currentPage = this.$store.state.kpiStore.active_page

      switch (currentPage) {
        case 'for_isupplier':
          this.exportDataVendorBaru('DB Vendor Baru', 'Vendor Baru')
          break
        case 'for_sap':
          this.exportDataVendorBaru('DB Vendor Baru SAP', 'Vendor Baru SAP')
          break
        case 'for_extend_sap':
          this.exportDataVendorBaru('DB extend to SAP', 'Extend to SAP')
          break
        case 'for_k3l':
          this.exportPq('DB PQ K3L', 'K3L')
          break
        case 'for_kplh':
          this.exportPqKplh('DB PQ KPLH', 'KPLH')
          break

        default:
          break
      }
    },
  },
  mounted() {
    // do nothing
  },
}
</script>
<style scoped>
.keterangan {
  color: white;
  background-color: red;
  padding: 0 0.3rem;
}
</style>
